import { render } from "./slidenote-14.vue?vue&type=template&id=2c23a15e"
import script from "./slidenote-14.vue?vue&type=script&lang=js"
export * from "./slidenote-14.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__